export default __webpack_public_path__ + "static/media/iconSeePictures.0890bab5.svg";